import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SchedulePayableDialogComponent } from './schedule-payable-dialog.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '../../../../shared/button/button.module';
import { NotificationBarModule } from '../../../shared/notification-bar/notification-bar.module';
import { LegfiCurrencyPipeModule } from '../../../../../pipes/format/legfi-currency.module';
import { LegfiDatePipeModule } from '../../../../../pipes/format/legfi-date.module';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatMomentDateModule } from '@angular/material-moment-adapter';


@NgModule({
    declarations: [
        SchedulePayableDialogComponent,
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatMomentDateModule,
        ReactiveFormsModule,
        ButtonModule,
        NotificationBarModule,
        LegfiCurrencyPipeModule,
        LegfiDatePipeModule,
        MatChipsModule,
    ],
})
export class SchedulePayableDialogModule
{
}
